var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('menu-item',{attrs:{"label":_vm.$t('load_profile')},on:{"click":_vm.module.load}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }